module.exports = "img/2.f3cd01.webp";